import { render, staticRenderFns } from "./IconBurger.vue?vue&type=template&id=45ee6a3b&"
import script from "./IconBurger.vue?vue&type=script&lang=js&"
export * from "./IconBurger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports